import React, { useState } from "react";
import { Card, Table, Button, Modal } from "react-bootstrap";
import { FiCalendar, FiPrinter, FiTrash2 } from "react-icons/fi";
import { Link } from "react-router-dom";

export default function RecentHRTransactions() {
  const [showModal, setShowModal] = useState(false);
  const [selectedId, setSelectedId] = useState(null);

  const [data, setData] = useState([
    {
      id: "TRX565545878",
      name: "Anthony Lewis",
      img: "assets/img/users/user-31.jpg",
      category: "Bonus",
      amount: "$15,000",
      date: "Jan 06, 2026",
      status: "Approved",
    },
    {
      id: "TRX654412454",
      name: "Brian Villalobos",
      img: "assets/img/users/user-32-1.jpg",
      category: "Training",
      amount: "$2,500",
      date: "Jan 05, 2026",
      status: "Pending",
    },
    {
      id: "TRX552145547",
      name: "Harvey Smith",
      img: "assets/img/users/user-29-1.jpg",
      category: "Commission",
      amount: "$124,500",
      date: "Jan 04, 2026",
      status: "Processing",
    },
    {
      id: "TRX254124457",
      name: "Stephan Peralt",
      img: "assets/img/users/user-56.jpg",
      category: "Reimbursement",
      amount: "$1,250",
      date: "Jan 03, 2026",
      status: "Pending",
    },
    {
      id: "TRX124512442",
      name: "Doglas Martini",
      img: "assets/img/users/user-31.jpg",
      category: "Payroll",
      amount: "$782,000",
      date: "Jan 02, 2026",
      status: "Processed",
    },
  ]);

  const handleDeleteClick = (id) => {
    setSelectedId(id);
    setShowModal(true);
  };

  const confirmDelete = () => {
    setData(data.filter((item) => item.id !== selectedId));
    setShowModal(false);
  };

  const getStatusClass = (status) => {
    switch (status) {
      case "Approved":
        return "status approved";
      case "Pending":
        return "status pending";
      case "Processing":
        return "status processing";
      case "Processed":
        return "status processed";
      default:
        return "status";
    }
  };

  return (
    <>
      <style>{`
        .card-ui {
          border-radius: 5px;
          border: 2px solid #e5e7eb;
          font-family: "Inter", sans-serif; /* 🔥 EXACT FONT STYLE */
        }

        .title {
          font-weight: 700;
          text-decoration: underline;
          font-size: 16px;
        }

        .view-btn {
          background: #f97316;
          border: none;
          padding: 6px 14px;
          border-radius: 6px;
          font-size: 13px;
        }

         .view-btn:hover {
          background: #f97316;
         
        }
        .table th {
          background: #f8fafc;
          font-weight: 600;
          font-size: 13px;
          color: #475569;
        }

        .table td {
          vertical-align: middle;
          font-size: 16px;
          font-weight: 500;
          color: #0f172a;
        }

        .avatar {
          width: 38px;
          height: 38px;
          border-radius: 50%;
          object-fit: cover;
        }

        .employee {
          display: flex;
          align-items: center;
          gap: 10px;
        }

        /* STATUS */
        .status {
          padding: 4px 10px;
          border-radius: 6px;
          font-size: 12px;
          font-weight: 500;
        }

        .approved { background: #dcfce7; color: #16a34a; }
        .pending { background: #ffe4e6; color: #e11d48; }
        .processing { background: #f3e8ff; color: #9333ea; }
        .processed { background: #e0f2fe; color: #0284c7; }

        .action-icons {
          display: flex;
          gap: 12px;
          font-size: 16px;
          color: #64748b;
          cursor: pointer;
        }

        .action-icons svg:hover {
          color: #f97316;
        }

        /* MODAL */
        .modal-content {
          border-radius: 12px;
          padding: 10px;
          text-align: center;
        }

        .delete-btn {
          background: #ef4444;
          border: none;
        }

        .cancel-btn {
          background: #e5e7eb;
          color: #000;
          border: none;
        }

        @media (max-width: 768px) {
          .table-responsive {
            overflow-x: auto;
          }
        }
      `}</style>

      <Card className="card-ui">
        <Card.Body>
          {/* HEADER */}
          <div className="d-flex justify-content-between align-items-center mb-3">
            <h5 className="title mb-0">Recent HR Transactions</h5>
            <link to="/payments-page"  className="text-decoration-none" >
            </link>
            <Button className="view-btn">View All</Button>
          </div>

          {/* TABLE */}
          <div className="table-responsive">
            <Table hover borderless>
              <thead>
                <tr>
                  <th>Transaction ID</th>
                  <th>Employee</th>
                  <th>Category</th>
                  <th>Amount</th>
                  <th>Date</th>
                  <th>Status</th>
                  <th></th>
                </tr>
              </thead>

              <tbody>
                {data.map((item) => (
                  <tr key={item.id}>
                    <td><Link to="/invoice-details" className="text-decoration-none text-dark" >
                                    {item.id}</Link></td>

               
               
                    <td>
<Link to="/invoice-details" className="text-decoration-none text-dark" >
                                    <div className="employee">
                        <img src={item.img} className="avatar" />
                        {item.name}
                      </div></Link>

                    
                    </td>

                    <td>{item.category}</td>
                    <td>{item.amount}</td>

                    <td>
                      <FiCalendar size={14} className="me-1" />
                      {item.date}
                    </td>

                    <td>
                      <span className={getStatusClass(item.status)}>
                        {item.status}
                      </span>
                    </td>

                    <td>
                      <div className="action-icons">
                        <FiPrinter />
                        <FiTrash2 onClick={() => handleDeleteClick(item.id)} />
                      </div>
                    </td>
                  </tr>
                ))}
              </tbody>
            </Table>
          </div>
        </Card.Body>
      </Card>

      {/* DELETE MODAL */}
      <Modal show={showModal} onHide={() => setShowModal(false)} centered>
        <Modal.Body>
          <h5>Are you sure?</h5>
          <p>Do you want to delete this transaction?</p>

          <div className="d-flex justify-content-center gap-3 mt-3">
            <Button className="cancel-btn" onClick={() => setShowModal(false)}>
              Cancel
            </Button>

            <Button className="delete-btn" onClick={confirmDelete}>
              Delete
            </Button>
          </div>
        </Modal.Body>
      </Modal>
    </>
  );
}